import React from "react";
import { connect } from "react-redux";

import { getListForTable, getIndicadores, descargarEntregasDiarias, LimpiarEntregasDiariasError, getEfectividadSucursales, getEfectividadHistorial } from "../../store/actions/dashboardActions.js";
import { getExcelGuias, LimpiarNombreExcel, descargarExcel } from "../../store/actions/gestionPaquetesActions";

import Grafica from "./Graficas.js";
import GraficaEfectividadSucursales from "./GraficaEfectividadSucursales.js";
import GraficaEfectividadHistorial from "./GraficaEfectividadHistorial.js";
import { ResumenGlobal, NotaEfectividad } from "./EfectividadNotas.js";
import { formatearFecha } from "./efectividadUtils.js";

import SweetAlert from "react-bootstrap-sweetalert";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

// @material-ui/icons
import Language from "@material-ui/icons/Language";
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import GetAppIcon from '@material-ui/icons/GetApp';
import AssignmentIcon from '@material-ui/icons/Assignment';
import EqualizerIcon from '@material-ui/icons/Equalizer';

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Table from "components/Table/Table.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";


import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import stylesSweetAlert from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

const useStyles = makeStyles(styles);
const useStylesAlert = makeStyles(stylesSweetAlert);

function Dashboard(props) {
  const [ enRuta, setEnRuta ] = React.useState(0);
  const [ totalGuias, setTotalGuias ] = React.useState(0);
  const [ idSucursalLogueada] = React.useState(localStorage.getItem('sucursal'));
  const [, setLoading ] = React.useState(false);
  const [ disabled, setDisabled ] = React.useState(false);

  const [ data, setData ] = React.useState(null);
  
  const [ ead, setead ] = React.useState(0);
  const [ rad, setrad ] = React.useState(0);

  const [ descargandoEntregas, setDescargandoEntregas ] = React.useState(false);

  // Efectividad por sucursal (tabla a_graficas_efectividad, un dia del historial).
  // Matriz (1) ve todas las sucursales + la evolucion global; otra sucursal solo su evolucion.
  const esMatriz = String(idSucursalLogueada) === "1";
  const [ fechaEfectividad, setFechaEfectividad ] = React.useState("");

  const classes = useStyles();
  const classesAlert = useStylesAlert();

  React.useEffect(() => {    
    // if(idSucursalLogueada>1){
        props.LimpiarExcel();
        setLoading(true);
        props.getIndicadores(idSucursalLogueada);
        props.getListForTable(idSucursalLogueada);
        if (esMatriz) {
          props.getEfectividadSucursales(null);
        }
        props.getEfectividadHistorial(idSucursalLogueada, 30);
    // }
  }, []);

  React.useEffect(()=>{
    if(props.indicadores){
      console.log(props.indicadores);
      setead(props.indicadores.ead);

      setrad(props.indicadores.rad);
    }
  },[props.indicadores]);

  // Al llegar los datos del dia, sincronizar el selector con la fecha realmente servida.
  React.useEffect(() => {
    if (props.efectividadSucursales && props.efectividadSucursales.fecha) {
      setFechaEfectividad(props.efectividadSucursales.fecha);
    }
  }, [props.efectividadSucursales]);

  React.useEffect(() => {
    setData(props.listData);    
    setLoading(false);

    if(props.listData){
      setEnRuta(props.listData.Repartos);
      setTotalGuias(props.listData.Tabla.totales.izq);
    }
  }, [props.listData]);

  React.useEffect(() => {
    if(props.excelFile!=null){
        setLoading(false);
        setDisabled(false);
        props.descargarExcel(props.excelFile);
        props.LimpiarExcel();
    }
}, [props.excelFile]);

  // Si la generacion/descarga del Excel falla, reactivar los botones de descarga
  React.useEffect(() => {
    if(props.excelError!=null){
        setLoading(false);
        setDisabled(false);
    }
}, [props.excelError]);

  const formattedData = data == null ? null : (        
      data.Tabla.izq.map((prop, key) => {
          let color = parseInt(prop.total) > 0 ? { cursor:'pointer', color:"#4caf50" } : { cursor:'', color:"#000" };    
          return [
              prop.titulo,
              prop.total,
              <Tooltip title="Descargar Excel" placement="top" key={key}>
              <GetAppIcon disabled={disabled} key={prop.key} style={color} onClick={() => {
                  // let obj = data.data.find(o => o.bitacora === prop.bitacora);
                  if(parseInt(prop.total) > 0){
                      downloadExcel(prop.key);
                  }
              }}/>
              </Tooltip>
          ]
      })
  );

  const downloadExcel = (tipo) =>{
    setLoading(true);
    setDisabled(true);
    props.getExcelGuias(tipo, idSucursalLogueada);
  };

  // Reporte Excel de entregas/devoluciones diarias por unidad (ultimos 30 dias).
  // Sucursal matriz (1) => todas las sucursales; cualquier otra => solo esa.
  const descargarEntregas = () => {
    setDescargandoEntregas(true);
    props.descargarEntregasDiarias(idSucursalLogueada)
      .catch(() => { /* el mensaje se muestra via SweetAlert (reducer) */ })
      .finally(() => setDescargandoEntregas(false));
  };

  const cambiarFechaEfectividad = (event) => {
    const fecha = event.target.value;
    setFechaEfectividad(fecha);
    props.getEfectividadSucursales(fecha);
  };

  const efectividadSucursales = props.efectividadSucursales;
  const fechasEfectividad = (efectividadSucursales && efectividadSucursales.fechas) || [];
  const historialEfectividad = props.efectividadHistorial;

  const errorEntregas = !props.entregasExcelError ? null : (
    <SweetAlert
      danger
      style={{ display: "block" }}
      title="Error!"
      onConfirm={() => props.LimpiarEntregasDiariasError()}
      onCancel={() => props.LimpiarEntregasDiariasError()}
      confirmBtnCssClass={classesAlert.button + " " + classesAlert.success}
    >
      {props.entregasExcelError}
    </SweetAlert>
  );

  return (
    <div>
      {errorEntregas}
      <GridContainer>
        <GridItem xs={12} sm={6} md={6} lg={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <LocalShippingIcon/>
              </CardIcon>
              <p className={classes.cardCategory}>En Ruta</p>
              <h3 className={classes.cardTitle}>{enRuta}</h3>
            </CardHeader>
            <CardFooter stats onClick={() => {
                // verRecolecciones("REALIZADO");
            }}>
                <div className={classes.stats}>
                    
                </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning">
                <AssignmentIcon/>
              </CardIcon>
              <p className={classes.cardCategory}>Entregas por Unidad</p>
              <h3 className={classes.cardTitle} style={{ fontSize: "1.1rem" }}>Últimos 30 días</h3>
            </CardHeader>
            <CardFooter stats>
              <Button color="success" size="sm" disabled={descargandoEntregas} onClick={descargarEntregas}>
                <GetAppIcon /> {descargandoEntregas ? "Generando..." : "Descargar Excel"}
              </Button>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="success" icon>
            <CardIcon color="success">
              <Language />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              Inventario
            </h4>
          </CardHeader>
        <CardBody>
          <GridContainer justify="space-between">
          <GridItem xs={12} sm={12} md={5}>
            <div className={classes.cardHeader}>
            <h4 className={classes.cardTitle}>En sucursal <label>( {totalGuias} Guías )</label></h4>
            </div>
            <br />
            <Table
              tableData = { 
                formattedData === null ? 
                [[
                  "Almacen Destino EAD",
                  0,
                  <GetAppIcon key="ead"/>
                ],[
                  "Almacen Destino OCU",
                  0,
                  <GetAppIcon key="ocu"/>
                ],[
                  "Almacen Trasbordo",
                  0,
                  <GetAppIcon key="tras"/>
                ],[
                  "Almacen Origen (Registradas)",
                  0,
                  <GetAppIcon key="orig"/>
                ],[
                  "Por Recibir",
                  0,
                  <GetAppIcon key="recibir"/>
                ],[
                  "En Transito",
                  0,
                  <GetAppIcon key="transito"/>
                ],[
                  "Almacen Origen (Por Recibir)",
                  0,
                  <GetAppIcon key="origrecibir"/>
                ]] : formattedData                
              }
                  />
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <Grafica ead={ead} rad={rad} />
          </GridItem>
          </GridContainer>
        </CardBody>
        </Card>
      </GridItem>
      </GridContainer>
      <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <EqualizerIcon />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              Efectividad por sucursal <small>(EAD y recolecciones, un valor por día)</small>
            </h4>
          </CardHeader>
          <CardBody>
            {props.efectividadError ? (<p style={{ color: "#f44336" }}>{props.efectividadError}</p>) : null}
            {esMatriz ? (
              <div>
                <GridContainer alignItems="center">
                  <GridItem xs={12} sm={4} md={3}>
                    <FormControl fullWidth>
                      <InputLabel htmlFor="fecha-efectividad">Día (historial disponible)</InputLabel>
                      <Select value={fechaEfectividad} onChange={cambiarFechaEfectividad} inputProps={{ id: "fecha-efectividad" }}>
                        {fechasEfectividad.map((f) => (
                          <MenuItem key={f} value={f}>{formatearFecha(f)}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={8} md={9}>
                    <ResumenGlobal global={efectividadSucursales ? efectividadSucursales.global : null} />
                  </GridItem>
                </GridContainer>
                <GraficaEfectividadSucursales
                  fecha={efectividadSucursales ? efectividadSucursales.fecha : null}
                  global={efectividadSucursales ? efectividadSucursales.global : null}
                  sucursales={efectividadSucursales ? efectividadSucursales.sucursales : []}
                />
                <br />
                <GraficaEfectividadHistorial
                  titulo="Evolución global por día (todas las sucursales, últimos 30 días)"
                  filas={historialEfectividad ? historialEfectividad.filas : []}
                />
              </div>
            ) : (
              <GraficaEfectividadHistorial
                titulo="Evolución por día de mi sucursal (últimos 30 días)"
                filas={historialEfectividad ? historialEfectividad.filas : []}
              />
            )}
            <NotaEfectividad />
          </CardBody>
        </Card>
      </GridItem>
      </GridContainer>
    </div>

  );
}

const mapStateToProps = (state) => {
  return {
      "listData": state.dashboard.dashboard_Data,
      "MensajeError": state.dashboard.dashboard_Error,
      "excelFile": state.gestionPaquetes.gestionPaquetes_Excel,
      "excelError": state.gestionPaquetes.gestionPaquetes_Excel_Error,
      "indicadores": state.dashboard.dashboard_Data_Indicadores,      
      "entregasExcelError": state.dashboard.dashboard_Entregas_Excel_Error,
      "efectividadSucursales": state.dashboard.dashboard_Efectividad_Sucursales,
      "efectividadHistorial": state.dashboard.dashboard_Efectividad_Historial,
      "efectividadError": state.dashboard.dashboard_Efectividad_Error,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
      "getListForTable": (sucursal) => dispatch(getListForTable(sucursal)),
      "getExcelGuias" : (tipo,sucursal) => dispatch(getExcelGuias(tipo,sucursal)),
      "descargarExcel": (excel) => dispatch(descargarExcel(excel)),
      "LimpiarExcel": () => dispatch(LimpiarNombreExcel()),
      "getIndicadores": (sucursal) => dispatch(getIndicadores(sucursal)),
      "descargarEntregasDiarias": (sucursal) => dispatch(descargarEntregasDiarias(sucursal)),
      "LimpiarEntregasDiariasError": () => dispatch(LimpiarEntregasDiariasError()),
      "getEfectividadSucursales": (fecha) => dispatch(getEfectividadSucursales(fecha)),
      "getEfectividadHistorial": (sucursal, dias) => dispatch(getEfectividadHistorial(sucursal, dias)),
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(Dashboard);
